import {
  // HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslateModule } from '@ngx-translate/core';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { ApiLoaderInterceptorService } from './services/api-loader-interceptor.service';
import { ApiService } from './services/api.service';
import { appEffects } from './store/app-effect';
import { reducers } from './store/app-reducers';

import { ConfigService } from './services/config.service';
import { APP_INITIALIZER } from '@angular/core';
export function initializeAppFactory(configService: ConfigService) {
  return () => {
    // Only load config on startup if the user has a token (already logged in)
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (token) {
      return configService.loadConfig();
    }
    return Promise.resolve();
  };
}

// Firebase is initialized dynamically by ConfigService after the encrypted config API response.
// No AngularFire providers here — this prevents premature Firebase init with empty keys.

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptorsFromDi()),
    ApiService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [ConfigService],
      multi: true,
    },
    provideStore(reducers),
    provideEffects(appEffects),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
    provideToastr({
      positionClass: 'toast-bottom-full-width',
      closeButton: true,
      toastClass: 'custom-toast',
      titleClass: 'custom-toast-title',
      messageClass: 'custom-toast-msg',
      easeTime: 500,
      timeOut: 3000,
      extendedTimeOut: 3000,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiLoaderInterceptorService,
      multi: true,
    },
    provideAnimationsAsync(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        isolate: false,
      })
    ),
  ],
};
